import { SET_SE_ACTION_APPOINTMENT_ID } from 'actions';

export function setSeActionAppointmentId(seActionAppointmentId: string) {
  return { seActionAppointmentId, type: SET_SE_ACTION_APPOINTMENT_ID };
}
